export enum ModalInfo {
  SUBMIT_CONTINUE = 'continue',
  SUBMIT_UPDATE = 'update',
  SUBMIT_CLOSE = "close"
}
export enum ModalSize{
  DAILOGSMALL = 'sm',
  DAILOGLARGE = 'lg',
  DAILOGMEDIUM = 'md',
  DAILOG_EXTRA_LARGE = 'xl',
  DAILOG_RIGHT = 'issue_right'
}
